<template>
  <div class="hot-list-companies">
    <sn-header :title="title">
      <div>
        <SnTabsV3 class="sn-tabs-v3" @change="tabChange" :tabs="tabs"></SnTabsV3>
      </div>
    </sn-header>
    <div class="hot-list-companies-content">
      <common-hot-ranking :data="data" :sentiment="sentiment"></common-hot-ranking>
    </div>
    <div class="hot-list-companies-footer">
    </div>
  </div>  
</template>

<script>
import SnTabsV3 from '@/components/common/SnTabsV3';
import SnHeader from '@/components/common/SnHeader';
import CommonHotRanking from '@/components/common/CommonHotRanking';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      tabs: ['不限正负', '正面', '负面'],
      companiesData: [],
      market: '全部',
      sentiment: '不限正负',
      marketOptions: [
        {
          value: '全部',
          label: '全部'
        },
        {
          value: 'A股',
          label: 'A股'
        },
        {
          value: '港股',
          label: '港股'
        },
        {
          value: '美股',
          label: '美股'
        },
        {
          value: '科创',
          label: '科创'
        },
        {
          value: '发债企业',
          label: '发债企业'
        }
      ],
      sentimentOptions: [
        {
          value: '不限正负',
          label: '不限正负'
        },
        {
          value: '正面',
          label: '正面'
        },
        {
          value: '负面',
          label: '负面'
        }
      ]
    };
  },
  props: {
    data: {
      type: Array
    },
    title: {
      type: String
    }
  },
  methods: {
    tabChange({ item }) {
      this.sentiment = item;
      this.$emit('change', item);
    },
    onMarketChange(res) {
      this.market = res;
      this.getRankCompany();
    },
    onSentimentChange(res) {
      this.sentiment = res;
      this.getRankCompany();
    },
    getRankCompany() {
      QuestionQuery.getRankCompany(this.market, this.sentiment).then(res => {
        this.companiesData = res;
      });
    }
  },
  components: {
    SnHeader,
    SnTabsV3,
    CommonHotRanking
  }
};
</script>

<style lang="scss" scoped>
.hot-list-companies {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  &-footer {
    width: 100%;
    height: 16px;
    background-color: #ffffff;
  }
  .select {
    width: 100px;
  }
  .sentimentSelect {
    margin-left: 10px;
  }
  .sn-tabs-v3 {
    margin-top: 9px;
  }
  &-content {
    height: 406px;
    overflow: auto;
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none;
  color: #666666;
  background-color: #f7f7fa !important;
}
</style>
